import Extend from 'flarum/common/extenders';
export default [
  // Forum-side extenders (none needed currently — picker is initialized
  // via app.initializers in index.js)
];